import {defineStore} from 'pinia';
import {ref} from 'vue';
import {AppInfo} from "@store/api/interfaces";

export type GroupType = 'change_country' | 'download_app'
export type SelectionType = 'country' | 'protocol'

export interface GroupSettings {
	title: string;
	list: Array<{
		headName: string;
		routeName: string;
		complete: boolean;
	}>;
}

export interface SelectionSettings {
	country: string|null;
	protocol: string|null;
	app: AppInfo|null;
}

export const useSettingsStore = defineStore('settings', () => {
	const group = ref({
		change_country: {
			title: "common.settings.title_country_change",
			list: [
				{
					headName: "common.settings.country",
					routeName: "SettingsCountry",
					complete: false,
				},
				{
					headName: "common.settings.protocol",
					routeName: "SettingsProtocol",
					complete: false,
				},
				{
					headName: "common.settings.os",
					routeName: "SettingsOs",
					complete: false,
				},
				{
					headName: "common.settings.key",
					routeName: "SettingsKey",
					complete: false,
				},
			]
		},

		download_app: {
			title: "common.settings.title_app_download",
			list: [
				{
					headName: "common.settings.os",
					routeName: "DownloadApp",
					complete: false
				}
			]
		},

		get_key: {
			title: "common.settings.title_app_setup",
			list: [
				{
					headName: "common.settings.key",
					routeName: "SettingsKey",
					complete: false
				}
			]
		},

		setup_app: {
			title: "common.settings.title_app_setup",
			list: [
				{
					headName: "common.settings.setting",
					routeName: "SettingsKey",
					complete: false
				}
			]
		},

		instructions: {
			title: "common.settings.title_instructions",
			list: [
				{
					headName: "common.settings.os",
					routeName: "DownloadApp",
					complete: false
				}
			]
		},
	});

	const selection = ref<SelectionSettings>({
		country: null,
		protocol: null,
		app: null,

		// change_country: {
		// 	country: null,
		// 	protocol: null,
		// },
		// download_app: {
		// 	country: null,
		// 	protocol: null,
		// },
	});

	const loadStateFromBrowserStorage = () => {
		const state = sessionStorage.getItem("settingsStore");
		if (!state) {
			return false;
		}
		const json = JSON.parse(state);

		//console.log('loadStateFromBrowserStorage', json);

		group.value = json.group;
		selection.value = json.selection;
	};

	const saveStateToBrowserStorage = () => {
		const state = {
			group: group.value,
			selection: selection.value,
		};
		sessionStorage.setItem("settingsStore", JSON.stringify(state));
	};

	const getCurrentGroup = (name: GroupType) => {
		return group.value?.[name];
	};

	const getCurrentSelection = (name: SelectionType) => {
		return selection.value?.[name];
	};

	const getPageIndex = (currentGroup: GroupSettings, routeName: string) => {
		return currentGroup?.list?.findIndex(page => page.routeName === routeName);
	};

	const getMaxActiveIndex = (currentGroup: GroupSettings) => {
		const lastCompleteIndex = currentGroup?.list.map(item => item.complete).lastIndexOf(true);
		return lastCompleteIndex === -1 ? 0 : lastCompleteIndex + 1;
	};

	const getPageByIndex = (currentGroup: GroupSettings, index: number) => {
		const page = currentGroup?.list?.[index];
		return page || false;
	};

	const getPageByName = (currentGroup: GroupSettings, name: GroupType) => {
		return currentGroup?.list?.find(page => page?.routeName === name);
	};

	const getFirstRouteName = (name: GroupType) => {
		const currentGroup = getCurrentGroup(name);
		if (!currentGroup) {
			return false;
		}

		const firstRoute = getPageByIndex(currentGroup, 0)
		return firstRoute?.routeName;
	};

	// loadStateFromBrowserStorage();

	return {
		group,
		selection,
		getCurrentGroup,
		getCurrentSelection,
		getFirstRouteName,
		getPageIndex,
		getPageByIndex,
		getPageByName,
		getMaxActiveIndex,
		loadStateFromBrowserStorage,
		saveStateToBrowserStorage,
	};
})
